export default __webpack_public_path__ + "static/media/504540321007533130a837053809a415.4dbeaee2.svg";